import BaseModel from '../core/BaseModel'
import WarrantyRepairTypeServiceModel from "./WarrantyRepairTypeServiceModel";
//import CategoriesModel from './CategoriesModel'
export default class ProductFromWarrantyRepairModel extends BaseModel {
    constructor() {
        super({
                name: "product_from_warranty_repair",
                tableName: 'core_warranty_repair_product_serial_number'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                serial_number: {
                    name: 'serial_number',
                    type: "String",
                    width: 11,
                    label: 'Serial number',
                    //filter: { type: 'input', match: 'custom', placeHolder: 'Nhập serial number'}
                },
                model_code: {
                    name: 'model_code',
                    type: "String",
                    width: 11,
                    label: 'Model sản phẩm',
                    //filter: { type: 'input', match: 'custom', placeHolder: 'Nhập model sản phẩm'}
                },
                product_name: {
                    name: 'product_name',
                    type: "String",
                    width: 11,
                    label: 'Tên sản phẩm',
                    //filter: { type: 'input', match: 'custom', placeHolder: 'Nhập tên sản phẩm'}
                },
                type_service: {
                    name: 'type_service',
                    type: "Selection",
                    label: 'Loại dịch vụ',
                    class: 'center',
                    dataType: 'Label',
                    width: 12,
                    sortable: false,
                    params: {select: 'code, name', variables: {status: {'_in': [1]}}},
                    models: new WarrantyRepairTypeServiceModel(),
                    // filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'}
                },
                process_status: {
                    name: 'process_status',
                    label: 'Trạng thái thực hiện',
                    type: "Selection",
                    dataType: 'Label',
                    class: 'center disabled-opacity',
                    width: 15,
                    disabled: true,
                    options: [
                        {value: 6, label: 'Đồng ý tiếp nhận'},
                        {value: 7, label: 'Từ chối tiếp nhận'},
                        {value: 8, label: 'Đã hỗ trợ xong'},
                        {value: 0, label: 'Chờ thực hiện'},
                        {value: 1, label: 'Đã thực hiện'},
                        {value: 2, label: 'KH từ chối'},
                        {value: 3, label: 'Không thực hiện'},
                        {value: 4, label: 'Đề nghị hủy SP'}],
                    //filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                process_status_recieve: {
                    name: 'process_status_recieve',
                    label: 'Trạng thái thực hiện',
                    type: "Selection",
                    dataType: 'Selection',
                    class: 'center disabled-opacity',
                    width: 15,
                    disabled: false,
                    options: [{value: 6, label: 'Đồng ý tiếp nhận'}, {value: 7, label: 'Từ chối tiếp nhận'}, {
                        value: 8,
                        label: 'Đã hỗ trợ xong'
                    }],
                    filter: {type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals',placeHolder:"Chọn trạng thái thực hiện"},
                },
                service_total_price_payment: {
                    name: 'service_total_price_payment',
                    type: "String",
                    label: 'Chi phí',
                    class: 'center right_td_unit_price',
                    width: 12,
                    // filter: {type: 'input', match: 'contains'},
                    //display: false
                },

                detail_product_serial: {
                    name: 'detail_product_serial',
                    class: 'center',
                    type: "Text",
                    width: 15,
                    callback: true,
                    label: 'Chi tiết',
                    //filter: { type: 'input', match: 'custom', placeHolder: 'Nhập tên sản phẩm'}
                },
            },)
    }

}